import { Navigate, Route, Routes } from 'react-router-dom'
import { AuthProvider, useAuth } from './auth'
import { I18nProvider } from './i18n'
import { DisplayModeProvider } from './displayMode'
import { ConfirmProvider, FullLoader, ToastProvider } from './components/ui'
import { RequireAuth, RequireRole } from './components/guards'
import AppLayout from './components/AppLayout'
import Login from './pages/Login'
import SetPassword from './pages/SetPassword'
import Dashboard from './pages/Dashboard'
import CalendarPage from './pages/CalendarPage'
import MyShifts from './pages/MyShifts'
import Profile from './pages/Profile'
import Balance from './pages/Balance'
import Team from './pages/admin/Team'
import OpenTimes from './pages/admin/OpenTimes'
import Approvals from './pages/admin/Approvals'

export default function App() {
  return (
    <I18nProvider>
      <DisplayModeProvider>
        <AuthProvider>
          <ToastProvider>
            <ConfirmProvider>
              <AppRoutes />
            </ConfirmProvider>
          </ToastProvider>
        </AuthProvider>
      </DisplayModeProvider>
    </I18nProvider>
  )
}

function AppRoutes() {
  const { loading } = useAuth()
  if (loading) return <FullLoader />
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/set-password" element={<SetPassword />} />
      <Route element={<RequireAuth />}>
        <Route element={<AppLayout />}>
          <Route index element={<Dashboard />} />
          <Route path="/calendar" element={<CalendarPage />} />
          <Route path="/my-shifts" element={<MyShifts />} />
          <Route path="/profile" element={<Profile />} />
          <Route element={<RequireRole min="supervisor" />}>
            <Route path="/approvals" element={<Approvals />} />
            <Route path="/open-times" element={<OpenTimes />} />
            <Route path="/team" element={<Team />} />
            <Route path="/balance" element={<Balance />} />
          </Route>
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
